import React, { useEffect, useState } from 'react';

const radioSelectorStyle = {
  container: {
    height: '27px',
    width: '200px',
    marginLeft: '25px',
    display: 'flex',
    boxSizing: 'border-box',
  },
  selected: {
    backgroundColor: '#fff',
    color: '#bb0060',
  },
  notSelected: {
    cursor: 'pointer',
  },
};

const SelectorTypeList = (props) => {
  const {leftValue, rightValue} = props;
  const [value, setValue] = useState(leftValue)

  // Gestion des appels API lors du changement de valeur du radio
  useEffect(() => {
    props.onChange(value);
  }, [value]);

  // Render du composant
  return (
    <div style={radioSelectorStyle.container}>
      <div
        className="radio-selector left-radio-selector"
        style={value === leftValue ? radioSelectorStyle.selected : radioSelectorStyle.notSelected}
        onClick={() => setValue(leftValue)}
      >
        {leftValue}
      </div>
      <div
        className="radio-selector right-radio-selector"
        style={value === rightValue ? radioSelectorStyle.selected : radioSelectorStyle.notSelected}
        onClick={() => setValue(rightValue)}
      >
        {rightValue}
      </div>
    </div>
  );
};

export default SelectorTypeList;
